/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistQuantitativeQuestionDTO} from './ChecklistQuantitativeQuestionDTO';

/**
 * The ChecklistQuantitativeDriverDTO model module.
 * @module model/ChecklistQuantitativeDriverDTO
 * @version v0
 */
export class ChecklistQuantitativeDriverDTO {
  /**
   * Constructs a new <code>ChecklistQuantitativeDriverDTO</code>.
   * @alias module:model/ChecklistQuantitativeDriverDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistQuantitativeDriverDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistQuantitativeDriverDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistQuantitativeDriverDTO} The populated <code>ChecklistQuantitativeDriverDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistQuantitativeDriverDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('checklistQuantitativeQuestions'))
        obj.checklistQuantitativeQuestions = ApiClient.convertToType(data['checklistQuantitativeQuestions'], [ChecklistQuantitativeQuestionDTO]);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistQuantitativeDriverDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
ChecklistQuantitativeDriverDTO.prototype.position = undefined;

/**
 * @member {String} title
 */
ChecklistQuantitativeDriverDTO.prototype.title = undefined;

/**
 * @member {Array.<module:model/ChecklistQuantitativeQuestionDTO>} checklistQuantitativeQuestions
 */
ChecklistQuantitativeDriverDTO.prototype.checklistQuantitativeQuestions = undefined;

